module.exports = __webpack_public_path__ + "img/域贝一体化平台.4f9a1b27.png";